import Image from 'global/Image';
import { handleErrorAvatar } from 'utils/general';
import { AvatarContainer, GroupAvatar } from '../styled';
import { ReceiverType } from '../utils';

interface ReceiverItemAvatarProps {
  type: ReceiverType,
  src: string;
  name: string;
  shortName: string;
}

function ReceiverItemAvatar({ type, src, name, shortName } : ReceiverItemAvatarProps) {
  if (type === 'RECEIVER_TYPE_USER') {
    return (
      <AvatarContainer>
        <Image
          alt={name}
          src={src}
          onError={(e) => handleErrorAvatar(e, name)}
        />
      </AvatarContainer>
    );
  }

  return (
    <AvatarContainer>
      {src === '' ? (
        <GroupAvatar>
          <span data-username={name}>{shortName}</span>
        </GroupAvatar>
      ) : (
        <Image
          alt={name}
          src={src}
          onError={(e) => handleErrorAvatar(e, name)}
        />
      )}
    </AvatarContainer>
  );
}

export default ReceiverItemAvatar;
